"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAccessSchema = void 0;
var constants_1 = require("@hobt/constants");
var access_schema_1 = require("./access-schema");
var claim_access_schema_1 = require("./claim-access-schema");
exports.userAccessSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'userID',
        'userAccessID',
        'allowedTransitNumbers',
        'financialInstitutionCode',
        'access',
        'recordCreatedTimestamp',
        'recordCreatedUserID',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'statusCode',
    ],
    properties: {
        userID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        userAccessID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        allowedTransitNumbers: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 5,
                maxLength: 5,
                errorMessage: 'should be of length 5 characters',
            },
            errorMessage: 'should be an array of transit numbers',
        },
        defaultFinancialInstitutionCode: {
            type: ['string', 'null'],
            minLength: 3,
            maxLength: 3,
            errorMessage: 'should be of length 3 characters',
        },
        defaultTransitNumber: {
            type: ['string', 'null'],
            minLength: 5,
            maxLength: 5,
            errorMessage: 'should be of length 5 characters',
        },
        financialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'should be of length 3 characters',
        },
        lenderCode: {
            type: ['string', 'null'],
            minLength: 5,
            maxLength: 5,
            errorMessage: 'should be of length 5 characters',
        },
        lenderRoleCode: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.UserRole), [null]),
            errorMessage: 'Should equate to a valid UserRole Enum value or null',
        },
        access: {
            type: 'object',
            additionalProperties: {
                not: true,
                /* eslint-disable-next-line no-template-curly-in-string */
                errorMessage: '- should not have additional property ${0#}',
            },
            required: [
                'admin',
                'arrears',
                'claim',
                'default',
                'piFileShare',
                'piPurposeTest',
                'piRequest',
            ],
            properties: {
                admin: access_schema_1.accessSchema,
                arrears: access_schema_1.accessSchema,
                claim: claim_access_schema_1.claimAccessSchema,
                default: access_schema_1.accessSchema,
                piFileShare: access_schema_1.accessSchema,
                piPurposeTest: access_schema_1.accessSchema,
                piRequest: access_schema_1.accessSchema,
            },
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        statusCode: {
            type: 'number',
            enum: Object.values(constants_1.UserAccessStatus),
            errorMessage: 'Should equate to a valid UserAccessStatus Enum value',
        },
        userAuthorizationScope: {
            type: 'array',
            minLength: 0,
            maxItems: 3,
            items: {
                type: 'string',
                enum: [
                    constants_1.UserAuthorizationScope.Arrears,
                    constants_1.UserAuthorizationScope.Claim,
                    constants_1.UserAuthorizationScope.Default,
                ],
                errorMessage: 'should be one valid UserAuthorizationScope enum',
            },
            errorMessage: 'should be an array of valid UserAuthorizationScope enum value',
        },
    },
};
